(function ($) {
  $(document).ready(function () {
    var app = {
      audio: {
        player: null,
      },
      video: {
        player: null,
        el: null,
        done: false,
      },
      map: {
        map: null,
        markers: [],
      },
      isMobile: false,
      isTablet: false,
      isMaxTablet: false,
      breakPointMenuBurger: 1200,
      breakPointMaxTablet: 1024,
      breakPointTablet: 992,
      breakPointMobile: 768,
      navHeight: 105,
      navHeightMobile: 80,
      navBreakpoint: 1199,
      init: function () {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty("--vh", `${vh}px`);
        app.handleResize();
        app.responsiveDetection();
        app.initFilterSelects();
        app.handleAsides();
        app.handlePortals();
        app.handleDropDown();
        app.handleBlocVideo();
        app.handleScroll();
        app.handleTabs();
        app.handleMenu();
        //app.youtubePlayer();
        app.initMasonryMag();
        app.initPlayer();
        app.initBlockMapList();
        app.initContactSelects();
        app.handleHovers();
        app.underlineTitle();
        app.closeArticleHome();
        app.handleHomeBehaviour();
        app.checkImage();
        app.arrowRemover();
        app.handleTextMore();
        app.swiperMap();
        // app.popinImageText();
        // $(document).ajaxComplete(function (e, x, s) {
        // });
      },

      handleTextMore: function () {
        var _read = $(".block-text .read-more");
        if (_read.length > 0) {
          _read.on("click", function (e) {
            var _this = $(this),
                _short = _this.parent().find(".short");
            if (!_this.hasClass("active")) {
              _this.addClass("active");
              _short.addClass("opened");
              _this.html(_this.data("less"));
            } else {
              _this.removeClass("active");
              _short.removeClass("opened");
              _this.html(_this.data("plus"));
            }
            e.preventDefault();
            return false;
          });
        }
      },

      checkImage: function () {
        if ($(".archive").length) {
          if ($("section").hasClass("archive-with-image")) {
            $("header .container").addClass("remove-line");
          }
        }
      },

      handleHomeBehaviour: function () {
        if ($(".home .block-text-cta.with-video").length) {
          const _parent = document.querySelector(
              ".home .block-text-cta.with-video",
          );
          const _titleEl = document.querySelector(
              ".block-text-cta.with-video .underlined-title",
          );
          const _descEl = document.querySelector(
              ".block-text-cta.with-video .desc",
          );
          const _cardEl =
              document.querySelector(
                  ".block-text-cta.with-video .card-preview",
              ) || 0;
          const paddings = 82;
          const margins = 100;
          const arrowHeight = 30;
          const neededHeight =
              _titleEl.scrollHeight +
              _descEl.scrollHeight +
              _cardEl.scrollHeight +
              paddings +
              margins +
              app.navHeightMobile +
              arrowHeight;
          if (window.innerWidth <= 1023) {
            _parent.style.minHeight = neededHeight + 100 + "px";
          } else {
            _parent.style.minHeight = `calc(100vh - 60px)`;
          }
        }
      },
      handleResize: function () {
        $(window).on("resize", function () {
          app.responsiveDetection();
          app.initBlockMapList();
          app.handleHomeBehaviour();
        });
      },
      responsiveDetection: function () {
        app.isMobile = $(window).width() < app.breakPointMobile;
        app.isTablet = $(window).width() < app.breakPointTablet;
        app.isMaxTablet = $(window).width() <= app.breakPointMaxTablet;
      },
      handleHovers: function () {
        // block-article-slider__article

        if ($(".block-article-slider__article").length > 0) {
          $(".block-article-slider__article").each(function () {
            var _el = $(this);
            _el.hover(
                () => {
                  _el.find(".cta.link").addClass("hover");
                },
                () => {
                  _el.find(".cta.link").removeClass("hover");
                },
            );
          });
        }
        if ($(".mag-item").length > 0) {
          $(".mag-item").each(function () {
            const _el = $(this);
            _el.hover(
                () => {
                  _el.find(".cta.link").addClass("hover");
                },
                () => {
                  _el.find(".cta.link").removeClass("hover");
                },
            );
          });
        }
      },
      handlePortals: function () {
        if ($(".block-portals").length > 0) {
          $(".block-portals__side").each(function () {
            var _el = $(this);
            _el.hover(
                () => {
                  _el.find(".cta.cta-bordered.white").addClass("hover");
                },
                () => {
                  _el.find(".cta.cta-bordered.white").removeClass("hover");
                },
            );
          });
        }
        if ($(".block-recrutment__content").length > 0) {
          $(".block-recrutment__content").each(function () {
            var _el = $(this);
            _el.hover(
                () => {
                  _el.find(".cta").addClass("hover");
                },
                () => {
                  _el.find(".cta").removeClass("hover");
                },
            );
          });
        }
      },
      handleBlocVideo: function () {
        let _videos = $(".block-video"),
            _plays = _videos.find(".block_video_play");

        if (_videos.length > 0) {
          _plays.on("click", function (e) {
            const ytId = $(this).data("yt-id");
            const closestVideoYoutube = $(this).closest(".video-youtube");
            const closestYoutubePlayer = closestVideoYoutube.find(".youtube_player");

            closestYoutubePlayer.attr("videoid", ytId);
            closestYoutubePlayer.html('<iframe src="https://www.youtube.com/embed/' + ytId + '?autoplay=1&mute=1" frameborder="0" allowfullscreen></iframe>');
            closestVideoYoutube.addClass("playvideo");
            e.preventDefault();
          });
        }

        window.addEventListener("scroll", function () {
          if (app.video.player != null) {
            app.video.player.pauseVideo();
          }
        });
      },

      stopVideo: function (e) {
        app.video.player.stopVideo();
      },

      onPlayerStateChange: function (e) {
        if (e.data == YT.PlayerState.PLAYING && !app.video.done) {
          app.video.el.find(".player-block").addClass("video_loaded");
          app.video.done = true;
        }
      },

      onPlayerReady: function (e) {
        e.target.playVideo();
      },


      handleScroll: function () {
        // POST FEATURED
        var _cPrev = $(".card-preview");
        if (_cPrev.length > 0) {
          _cPrev.find(".close").on("click", function (e) {
            gsap.to(_cPrev, {
              yPercent: -15,
              opacity: 0,
              onComplete: function () {
                _cPrev.hide();
              },
            });
            e.preventDefault();
            return false;
          });
        }
        // SCROLL DOWN
        var _scDwn = $(".scroll-btn");
        if (_scDwn.length > 0) {
          _scDwn.on("click", function () {
            var _element = $(".block-logo-text");
            var scrollTop = _element.offset().top;
            $(this).hide();
            if (window.innerWidth < app.navBreakpoint) {
              gsap.to(window, {
                duration: 0.5,
                scrollTo: scrollTop - app.navHeightMobile,
                ease: Expo.easeOut,
              });
            } else {
              gsap.to(window, {
                duration: 0.5,
                scrollTo: scrollTop - app.navHeight,
                ease: Expo.easeOut,
              });
            }
          });
        }
      },

      youtubePlayer: function () {
        if ($(".with-video").length) {
          var player;

          function onYouTubeIframeAPIReady() {
            player = new YT.Player("player", {
              height: "360",
              width: "640",
              videoId: "M7lc1UVf-VE",
              events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange,
              },
            });
          }

          function onPlayerReady(event) {
            event.target.playVideo();
          }

          var done = false;

          function onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.PLAYING && !done) {
              setTimeout(stopVideo, 6000);
              done = true;
            }
          }

          function stopVideo() {
            player.stopVideo();
          }
        }
      },

      handleTabs: function () {
        // TABS
        if ($(".tabs").length > 0) {
          $(".tab-left-part__title").click(function () {
            var tab = $(this).attr("id");
            var is_open = $(this).hasClass("open");
            if (!is_open) {
              $(this).addClass("open").siblings().removeClass("open");
              $(".remove-border").removeClass("remove-border");
              $(this).prev().addClass("remove-border");
              $("#" + tab + "C")
                  .removeClass("close")
                  .siblings()
                  .addClass("close");
            }
          });
        }
      },
      handleDropDown: function () {
        // DROPDOWN
        if (
            $(".dropdown").length > 0 ||
            $(".tabs-mobile").length > 0 ||
            $(".a-dropdown").length > 0
        ) {
          $(".dropd-item__title").on("click", function (e) {
            var is_open = $(this).parent().hasClass("open");
            var chevron = $(".icon-chevron-down", this);
            if (is_open) {
              $(this).parent().removeClass("open");
              chevron.removeClass("arrow-rotate");
            } else {
              $(this).parent().addClass("open");
              chevron.addClass("arrow-rotate");
            }
          });
        }
      },
      formatCountryLink: function (state, container) {
        if (!state.id) {
          return state.text;
        }
        var $state = $(
            '<a href="' +
            $(state.element).data("url") +
            '">' +
            state.text +
            "</a>",
        );
        return $state;
      },
      handleMenu: function () {
        var _header = $("header.header");
        const _headerSelect = $(".header-select");
        if (_header.length > 0) {
          _headerSelect.select2({
            closeOnSelect: false,
            placeholder:
                $(this).data("placeholder") && $(this).data("placeholder").length
                    ? $(this).data("placeholder")
                    : "Selectionnez dans la liste.",
            dropdownCssClass: "header-dropdown",
            templateResult: app.formatCountryLink,
            minimumResultsForSearch: -1,
          });
          //
          // _headerSelect.on('select2:opening', function () {
          //     _headerSelect.val("").trigger("change");
          // })

          // _headerSelect.on('select2:open', function () {
          //     $('#select2-select-pays-header-results').show();
          // })

          _headerSelect.on("change", function () {
            setTimeout(function () {
              $(".header-select").select2("close");
            }, 10);
            $("#select2-select-pays-header-results").hide();
          });

          // if (window.scrollY > 0) {
          //     $('body').addClass('header_is_sticky');
          //     $('.block-text-cta .container .row .col-12 .underlined-title.title').addClass('big-text');
          //     _header.addClass('blured is_sticky');
          // } else {
          //     $('body').removeClass('header_is_sticky');
          //     _header.removeClass('blured is_sticky');
          //     $('.block-text-cta .container .row .col-12 .underlined-title.title').removeClass('big-text');
          // }
          $(window).on("scroll", function () {
            if (
                !$("body").hasClass("mega-menu-menu-1-mobile-open") &&
                !$("html").hasClass("menu-opened")
            ) {
              if (window.scrollY > 10) {
                $("body").addClass("header_is_sticky");
                _header.addClass("blured is_sticky");
                $(
                    ".block-text-cta .container .row .col-12 .underlined-title.title",
                ).addClass("big-text");
              } else {
                $("body").removeClass("header_is_sticky");
                _header.removeClass("blured is_sticky");
                $(
                    ".block-text-cta .container .row .col-12 .underlined-title.title",
                ).removeClass("big-text");
              }
            }
          });
          $(window).trigger("scroll");

          window.addEventListener("resize", function () {
            if (
                window.innerWidth >= app.breakPointMaxTablet &&
                $("body").hasClass("mega-menu-menu-1-mobile-open")
            ) {
              $("body").removeClass("mega-menu-menu-1-mobile-open");
              $(".mega-menu-open").removeClass("mega-menu-open");
            }
          });

          $(".mega-menu-link").on("click", function () {
            var _this   = $(this),
                _parent = _this.parent();
            if( _parent.hasClass("mega-menu-item-has-children") ) {
              $("#masthead").addClass("menu-link-opened");
              $("body").addClass("no-scroll");
            }
          });
          $(".mega-toggle-animated").on("click", function () {
            function disableScroll() {
              // Get the current page scroll position
              scrollTop =
                  window.pageYOffset || document.documentElement.scrollTop;
              (scrollLeft =
                  window.pageXOffset || document.documentElement.scrollLeft),
                  // if any scroll is attempted,
                  // set this to the previous value
                  (window.onscroll = function () {
                    window.scrollTo(scrollLeft, scrollTop);
                  });
            }

            function enableScroll() {
              window.onscroll = function () {};
            }

            if (!$("body").hasClass("mega-menu-menu-top-mobile-open")) {
              $("html").addClass("menu-opened");
              disableScroll();
            } else {
              $("html").removeClass("menu-opened");
              enableScroll();
              if (window.scrollY > 10) {
                $("body").addClass("header_is_sticky");
                _header.addClass("blured is_sticky");
                $(
                    ".block-text-cta .container .row .col-12 .underlined-title.title",
                ).addClass("big-text");
              } else {
                $("body").removeClass("header_is_sticky");
                _header.removeClass("blured is_sticky");
                $(
                    ".block-text-cta .container .row .col-12 .underlined-title.title",
                ).removeClass("big-text");
              }
            }
          });
          $(".nav-close-btn").on("click", function (e) {
            $("#mega-menu-menu-1 li.mega-menu-item.mega-toggle-on").removeClass(
                "mega-toggle-on",
            );
            $("#masthead").removeClass("menu-link-opened");
            $("body").removeClass("no-scroll");
            $(this).parent().focus();
          });
          $(".nav-back-btn").on("click", function (e) {
            $(
                "#mega-menu-menu-top li.mega-menu-item.mega-toggle-on",
            ).removeClass("mega-toggle-on");
            $("#masthead").removeClass("menu-link-opened");
            e.preventDefault();
            return false;
          });
          $(document).on("click touchend", function (e) {
            // hide menu when clicked away from
            if (
                !$(e.target).closest(".max-mega-menu li").length &&
                !$(e.target).closest(".mega-menu-toggle").length
            ) {
              var _mastHeader = $("#masthead");
              if (_mastHeader.hasClass("menu-link-opened")) {
                _mastHeader.removeClass("menu-link-opened");
              }
            }
            dragging = false;
          });
        }
      },
      handleAsides: function () {
        const _with_aside = $(".with-aside");
        const _block_contact = $(".block-contact");
        if (_with_aside.length > 0) {
          _with_aside.each(function () {
            const container = $(this);
            container.find(".block-aside").each(function () {
              gsap.to($(this), {
                yPercent: -50,
                scrollTrigger: {
                  scrub: true,
                  trigger: container,
                },
              });
            });
          });
        }
        if (_block_contact.length > 0) {
          if (window.innerWidth > 1023) {
            gsap.to($(".block-contact__content"), {
              yPercent: -15,
              scrollTrigger: {
                scrub: true,
                trigger: _block_contact,
              },
            });
          } else {
            gsap.to($(".block-contact__content"), {
              yPercent: -5,
              scrollTrigger: {
                scrub: true,
                trigger: _block_contact,
              },
            });
          }
        }
      },
      initPlayer: function () {
        if ($(".block-podcast").length > 0) {
          if (app.audio.player != null) {
            app.audio.player.pause();
          }
          $(".block-podcast").map(function (i, el) {
            var _audio = $(el);
            var sound_status = 0,
                player = _audio.find(".music"), // id for audio element
                duration; // Duration of audio clip
            source = _audio.find(".audioSource");
            totalTime = _audio.find(".total-time");
            totalTime.map(function (i, el) {
              $(el)[0].innerHTML = app.secToDigit(player[0].duration);
            });
          });

          var btnPlayPause = $(".block-podcast .play"),
              backwardButton = $(".block-podcast .backward-btn"),
              progressBar = $(".block-podcast .progress-bar"),
              forwardButton = $(".block-podcast .forward-btn");

          btnPlayPause.map(function (i, el) {
            $(el).on("click", function (e) {
              var _this = $(this),
                  _parent = _this.parents(".block-podcast"),
                  player = _parent.find(".music"),
                  id = player.attr("id"),
                  totalTime = _parent.find(".total-time");

              if (
                  app.audio.player != null &&
                  id != app.audio.player.attr("id")
              ) {
                app.resetPlayer();
              }
              if (
                  (app.audio.player != null &&
                      id != app.audio.player.attr("id")) ||
                  app.audio.player == null
              ) {
                app.audio.player = player;
                app.audio.totalTime = totalTime;
                app.bindPlayerEvents();
              }
              app.playPauseAudio(_parent);
            });
          });

          backwardButton.map(function (i, el) {
            $(el).on("click", function () {
              app.shiftTime(-15);
            });
          });
          forwardButton.map(function (i, el) {
            $(el).on("click", function () {
              app.shiftTime(15);
            });
          });
          progressBar.on("click", app.seek);

          document.addEventListener("scroll", function (e) {
            if (app.audio.player != null) {
              app.audio.player[0].pause();
            }
          });
        }
      },

      bindPlayerEvents: function () {
        app.audio.player[0].removeEventListener("play", app.playPlayer, false);
        app.audio.player[0].addEventListener("play", app.playPlayer, false);

        app.audio.player[0].removeEventListener(
            "pause",
            app.pausePlayer,
            false,
        );
        app.audio.player[0].addEventListener("pause", app.pausePlayer, false);

        app.audio.player[0].removeEventListener(
            "ended",
            app.endedPlayer,
            false,
        );
        app.audio.player[0].addEventListener("ended", app.endedPlayer, false);

        app.audio.player[0].removeEventListener(
            "timeupdate",
            app.updateProgressBar,
            false,
        );
        app.audio.player[0].addEventListener(
            "timeupdate",
            app.updateProgressBar,
            false,
        );
      },

      endedPlayer: function () {
        this.pause();
      },

      playPlayer: function () {
        var _this = $(this),
            _parent = _this.parents(".block-podcast"),
            btnPlayPause = _parent.find(".play");
        btnPlayPause.map(function (i, btn) {
          app.changeButtonType($(btn), "pause-video");
        });
      },

      pausePlayer: function (e) {
        var _this = $(this),
            _parent = _this.parents(".block-podcast"),
            btnPlayPause = _parent.find(".play");

        if (window.innerWidth < 1023) {
          btnPlayPause.map(function (i, btn) {
            app.changeButtonType($(btn), "play-mobile");
          });
        } else {
          btnPlayPause.map(function (i, btn) {
            app.changeButtonType($(btn), "play");
          });
        }
      },

      resetPlayer: function () {
        $(".block-podcast .progress-bar").map(function (i, el) {
          $(el)[0].value = 0;
        });
        app.audio.player[0].pause();
        app.audio.player[0].currentTime = 0;
        app.audio.player = null;
        var btnPlayPause = $(".block-podcast .play");

        if (window.innerWidth < 1023) {
          btnPlayPause.map(function (i, el) {
            app.changeButtonType($(el), "play-mobile");
          });
        } else {
          btnPlayPause.map(function (i, el) {
            app.changeButtonType($(el), "play");
          });
        }
      },

      seek: function (e) {
        // if (app.audio.player.src) {
        var percent = e.offsetX / this.offsetWidth;
        app.audio.player[0].currentTime =
            percent * app.audio.player[0].duration;
        e.target.value = Math.floor(percent / 100);
        e.target.innerHTML = app.audio.progressBar.value + "% played";
        // }
      },

      secToDigit: function (sec) {
        var oMinutes = (sec.toFixed() / 60).toFixed(),
            oSecondes = sec.toFixed() - oMinutes * 60;
        return `${("0" + oMinutes).slice(-2)}:${("0" + oSecondes).slice(-2)}`;
      },

      shiftTime: function (sec) {
        app.audio.player[0].currentTime += sec;
      },

      // Update the progress bar
      updateProgressBar: function (e) {
        var _audio = $(e.target),
            _parent = _audio.parents(".block-podcast"),
            actualTime = _parent.find(".actual-time"),
            progressBar = _parent.find(".progress-bar");
        // Work out how much of the media has played via the duration and currentTime parameters
        var percentage = Math.floor(
            (100 / app.audio.player[0].duration) *
            app.audio.player[0].currentTime,
        );
        // Update the progress bar's value
        // actual-time
        actualTime[0].innerHTML = app.secToDigit(
            app.audio.player[0].currentTime,
        );
        progressBar[0].value = percentage;
        // Update the progress bar's text (for browsers that don't support the progress element)
        progressBar[0].innerHTML = progressBar[0].title =
            percentage + "% played";
      },

      // Updates a button's title, innerHTML and CSS class
      changeButtonType: function (btn, value) {
        btn[0].className = "play icon-btn-" + value;
      },

      playPauseAudio: function (podcast) {
        // if (app.audio.player.src) {
        podcast.find(".total-time").map(function (i, el) {
          $(el)[0].innerHTML = app.secToDigit(app.audio.player[0].duration);
        });

        if (app.audio.player[0].paused || app.audio.player[0].ended) {
          podcast.find(".play").map(function (i, el) {
            app.changeButtonType($(el), "pause-video");
          });
          app.audio.player[0].play();
        } else {
          // Change the button to a play button
          if (window.innerWidth < 1023) {
            podcast.find(".play").map(function (i, el) {
              app.changeButtonType($(el), "play-mobile");
            });
          } else {
            podcast.find(".play").map(function (i, el) {
              app.changeButtonType($(el), "play");
            });
          }
          app.audio.player[0].pause();
        }
        // }
      },

      initGMap: function () {
        // Set your google maps parameters
        var latitude = 46.2192649,
            longitude = 2.0517,
            map_zoom = 4;
        //
        // //google map custom marker icon - .png fallback for IE11
        var is_internetExplorer11 =
            navigator.userAgent.toLowerCase().indexOf("trident") > -1;
        var marker_url = is_internetExplorer11
            ? window.cnsrt_vars.uri + "/assets/img/communs/pin.png"
            : window.cnsrt_vars.uri + "/assets/img/communs/pin.svg";
        var marker_icon = {
          url: marker_url,
          // size: new google.maps.Size(107, 150),
          // The origin for this image is (0, 0).
          // origin: new google.maps.Point(0, 0),
          // The anchor for this image is the base of the flagpole at (0, 32).
          // anchor: new google.maps.Point(0, 150),
        };
        //we define here the style of the map
        var style = [
          {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#444444"
              }
            ]
          },
          {
            "featureType": "administrative.country",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#6f6f6f"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
              {
                "color": "#f2f2f2"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              },
              {
                "lightness": 45
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "color": "#d0d0d0"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#d2d2d2"
              }
            ]
          }
        ]

        //set google map options
        var map_options = {
          center: new google.maps.LatLng(latitude, longitude),
          zoom: map_zoom,
          panControl: false,
          zoomControl: true,
          mapTypeControl: false,
          disableDefaultUI: true,
          streetViewControl: false,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          scrollwheel: true,
          styles: style,
        };
        // Inizialize the map
        app.map.map = new google.maps.Map(
            document.getElementById("map"),
            map_options,
        );

        if (typeof window.pins != "undefined") {
          window.pins.map(function (el, i) {
            var marker;
            // add custom marker to the map
            if (el.lat != "" && el.lon != "") {
              if (is_internetExplorer11) {
                marker = new google.maps.Marker({
                  position: new google.maps.LatLng(
                      parseFloat(el.lat),
                      parseFloat(el.lon),
                  ),
                  map: app.map.map,
                  icon: marker_icon,
                });
              } else {
                marker = new google.maps.Marker({
                  position: new google.maps.LatLng(
                      parseFloat(el.lat),
                      parseFloat(el.lon),
                  ),
                  map: app.map.map,
                  label: {
                    text: "\ue91f",
                    fontFamily: "'icomoon'",
                    color: "#000000",
                    fontSize: "35px",
                  },
                  icon: " ",
                  scale: 0,
                });
              }
              app.map.markers.push(marker);
            }
          });
        }
      },
      isGmapLoaded: function () {
        if (typeof google === "object" && typeof google.maps === "object") {
          function getLangCookieValue() {
            const cookie = document.cookie
                .split(";")
                .find((c) => c.trim().startsWith("wp-wpml_current_language="));

            if (!!cookie) {
              const cookieValue = cookie.split(/=(.*)/s)[1];

              if (!!cookieValue) {
                const oldScript = document.querySelector(
                    `script[src*="https://maps.googleapis.com/maps/api/js"]`,
                );
                const newScriptTag = oldScript.src;

                oldScript.remove();
                document
                    .querySelectorAll(
                        'script[src^="https://maps.googleapis.com"]',
                    )
                    .forEach((script) => {
                      script.remove();
                    });
                if (google) delete google.maps;

                const newScript = document.createElement("script");
                newScript.src =
                    newScriptTag +
                    "&language=" +
                    cookieValue +
                    "&callback=googleMapsAPILoaded";

                window.googleMapsAPILoaded = () => {
                  let event = new CustomEvent("googleMapsAPILoaded");
                  window.dispatchEvent(event);
                };

                let apiLoaded = new Promise((resolve) => {
                  window.addEventListener("googleMapsAPILoaded", () => {
                    resolve();
                  });
                });

                document.body.appendChild(newScript);
                return apiLoaded;
              }
            }
          }

          getLangCookieValue().then(() => {
            app.initGMap();
          });
        } else {
          setTimeout(function () {
            app.isGmapLoaded();
          }, 500);
        }
      },
      swiperMap: function () {
        var map = $("#map");
        if (map.length > 0) {

          document.addEventListener(
              "googlemaps_added",
              app.isGmapLoaded(),
              false,
          );

          const GMapAuthorizeContainer = document.querySelector(
              "#googlemaps_forbiden",
          );

          function showGMapAuthorize() {
            const GMapAuthorizeContent = document.querySelector(
                ".tarteaucitron-magic-block-googlemaps",
            );

            GMapAuthorizeContainer.insertBefore(
                GMapAuthorizeContent,
                GMapAuthorizeContainer.firstChild,
            );
            GMapAuthorizeContainer.style.display = "grid";
            GMapAuthorizeContent.style.display = "flex";
          }

          function isAuthorizeContentLoaded() {
            if (
                document.querySelector(
                    ".tarteaucitron-magic-block-googlemaps",
                ) !== null
            ) {
              showGMapAuthorize();
            } else {
              setTimeout(function () {
                isAuthorizeContentLoaded();
              }, 500);
            }
          }

          (function getTarteaucitronCookieValue() {
            const cookie = document.cookie
                .split(";")
                .find((c) => c.trim().startsWith("tarteaucitron="));

            if (!!cookie) {
              const cookieValue = cookie.split(/=(.*)/s)[1];

              if (cookieValue.includes("!googlemaps=false")) {
                isAuthorizeContentLoaded();
              }
            }
          })();

          document.addEventListener("googlemaps_disallowed", function () {
            isAuthorizeContentLoaded();
          });
          document.addEventListener("googlemaps_allowed", function () {
            GMapAuthorizeContainer.style.display = "none";
          });
        }
        if ($(".swiper-map").length > 0) {
          var breakpoint = window.matchMedia("(max-width:991px)");
          var swiperMap;

          var breakpointChecker = function () {
            // if larger viewport and multi-row layout needed
            if (breakpoint.matches === false) {
              // clean up old instances and inline styles when available
              if (swiperMap !== undefined) swiperMap.destroy(true, true);
              // or/and do nothing
              return;
              // else if a small viewport and single column layout needed
            } else if (breakpoint.matches === true) {
              // fire small viewport version of swiper
              return enableSwiper();
            }
          };

          var enableSwiper = function () {
            swiperMap = new Swiper(".swiper-map", {
              // loop: true,
              slidesPerView: "auto",

              // Navigation arrows
              navigation: {
                nextEl: ".swiper-mag-next",
                prevEl: ".swiper-mag-prev",
              },

              // pagination
              pagination: {
                el: ".swiper-mag-pagination",
                clickable: true,
              },
              // paginationClickable: true,
            });
          };

          // keep an eye on viewport size changes
          breakpoint.addListener(breakpointChecker);
          breakpointChecker();
        }
      },
      initBlockMapList: function () {
        if ($(".block-map-list #map").length > 0) {
          if (!app.isMobile && !app.isTablet) {
            var h = $(".block-map-list #map").height();
            var h2 = $(".block-map-list__content .header").innerHeight();
            var h3 = h - h2;
            $(".block-map-list__content .rows").css("height", h3 + "px");
          } else {
            $(".block-map-list__content .rows").css("height", "auto");
          }
        }
      },

      initContactSelects: function () {
        var _contactFormSelect = $(".contact-form-select");
        if (_contactFormSelect.length > 0) {
          _contactFormSelect.each(function () {
            $(this).select2({
              dropdownParent: $(this).parent(),
              placeholder:
                  $(this).data("placeholder") &&
                  $(this).data("placeholder").length
                      ? $(this).data("placeholder")
                      : window.cnsrt_vars.select_val,
              minimumResultsForSearch: -1,
            });
          });
          document.addEventListener(
              "wpcf7mailsent",
              function (event) {
                // TODO : confirmation page
                if (window.contact.form == event.detail.contactFormId) {
                  window.location = window.contact.confirm;
                }
              },
              false,
          );
        }
      },

      initFilterSelects: function () {
        var _blockFilters = $(".block-filters");

        var urlParams = new URLSearchParams(window.location.search),
            _offer = urlParams.get("tag"),
            _country = urlParams.get("pays");

        if (_offer != null || _country != null) {
          //_blockFilters
          $("html, body").animate(
              { scrollTop: _blockFilters.position().top - app.navHeightMobile },
              "slow",
          );
        }

        if (_blockFilters.length > 0) {
          _blockFilters.find(".select").each(function () {
            $(this).select2({
              dropdownParent: $(this).parent(),
              placeholder:
                  $(this).data("placeholder") &&
                  $(this).data("placeholder").length
                      ? $(this).data("placeholder")
                      : "Selectionnez dans la liste.",
              minimumResultsForSearch: -1,
            });
            $(this).on("change", function (e) {
              var _id = $(this).attr("id"),
                  _tag = _id == "select-filter-pays" ? "pays" : "tag",
                  _val = $(this).val();

              var url = window.location.href.split("?")[0];
              if (_val != "all-filters") {
                url += "?" + _tag + "=" + _val;
              }
              window.location.href = url;
            });
          });
        }
      },


      initMasonryMag: function () {
        var _grid = $(".mag");
        if (_grid.length > 0) {
          _grid.imagesLoaded(function () {
            _grid.isotope({
              itemSelector: ".mag-item",
              percentPosition: true,
              masonry: {
                columnWidth: ".mag-sizer",
                horizontalOrder: true,
              },
            });
          });
        }
      },

      underlineTitle: function () {
        var lines = $(".underlined");
        if (lines.length) {
          const checkLines = function () {
            lines.each(function () {
              const line = $(this);
              var top_of_element = line.offset().top;
              var bottom_of_element = line.offset().top + line.outerHeight();
              var bottom_of_screen =
                  $(window).scrollTop() + $(window).innerHeight();
              var top_of_screen = $(window).scrollTop();
              if (
                  bottom_of_screen > top_of_element - 50 &&
                  top_of_screen < bottom_of_element
              ) {
                line.removeClass("underlined-right");
              }
            });
          };
          checkLines();
          $(window).scroll(checkLines);
        }
      },
      closeArticleHome: function () {
        const _card = $(".card-preview");
        if ($("body").hasClass("home")) {
          if (window.matchMedia("(max-width: 880px)").matches) {
            const _section = $(".block-text-cta");
            let articleHeight = _card.height();
            _section.css("height", "calc(var(--vh, 1vh) * 100)");

            $(".card-preview .close").click(function () {
              if (window.innerWidth <= 1023) {
                _card.css("display", "none");
              } else {
                _card.css("opacity", 0);
                _card.css("pointer-events", "none");
              }
              $(".block-text-cta.with-video").addClass("card-closed");
            });
          }
        }
      },
      arrowRemover: function () {
        const _arrow = $(".block-text-cta__scroll");
        const _card = $(".card-preview");

        if (_card.length) {
          if (window.matchMedia("(max-width: 880px)").matches) {
            _arrow.css("display", "none");
          }

          $(".card-preview .close").click(function () {
            _arrow.css("display", "block");
            $(".underlined-title").addClass("little-screen");
          });
        }
      },

    };
    app.init();
  });
})(jQuery);
